import Delhi from "../../assets/city/delhi.jpg";
import Noida from "../../assets/city/noida.jpg";
import Greater_Noida from "../../assets/city/g-noida.jpg";
import Ghaziabad from "../../assets/city/Ghaziabad.png";
import Gurugram from "../../assets/city/gurugram.jpg";
import Faridabad from "../../assets/city/faridabad.jpg";
import Lucknow from "../../assets/city/lucknow.jpg";
import Chandigarh from "../../assets/city/chanadigarh.jpg";
import Mohali from "../../assets/city/mohali.jpg";
// import Jammu from "../../assets/city/jammu.jpg";
import Dehradun from "../../assets/city/Dehradun.jpg";
import Meerut from "../../assets/city/meerut.jpg";
import Bareilly from "../../assets/city/Bareilly.jpg";
import Pathankot from "../../assets/city/pathankot.jpg";
import Jaipur from "../../assets/city/jaipur.jpg";
import Bhubaneswar from "../../assets/city/bhubneshwar.jpg";
// import Nagpur from "../../assets/city/nagpur.jpg";
import Kathmandu_Nepal from "../../assets/city/kathmandu.jpg";
import Banglore from "../../assets/city/banglore.jpg";
import Gwalior from "../../assets/city/gwalior.jpg";
import Zirakpur from "../../assets/city/zirakpur.jpg";
import Barabanki from "../../assets/city/barabanki.jpg";

export const cities = [
  { name: "Delhi", placeId: "ChIJLbZ-NFv9DDkRQJY4FbcFcgM", url: Delhi },
  { name: "Noida", placeId: "ChIJezVzMaTlDDkRP8B8yDDO_zc", url: Noida },
  {
    name: "Greater Noida",
    placeId: "ChIJ75r4uGTqDDkRLpYXU7vKDOw",
    url: Greater_Noida,
  },
  { name: "Ghaziabad", placeId: "ChIJ3w_FQbvxDDkRuph3atJv8OY", url: Ghaziabad },
  { name: "Gurugram", placeId: "ChIJWYjjgtUZDTkRHkvG5ehfzwI", url: Gurugram },
  { name: "Faridabad", placeId: "ChIJsSSk9RXcDDkR8uBQyHYF9eQ", url: Faridabad },
  { name: "Lucknow", placeId: "ChIJa7EyH5n9mzkR54uXCYm6zJM", url: Lucknow },
  {
    name: "Chandigarh",
    placeId: "ChIJa8lu5gvtDzkR_hlzUvln_6U",
    url: Chandigarh,
  },
  { name: "Mohali", placeId: "ChIJH_imbZDuDzkR2AjlbPGYKVE", url: Mohali },
  //   { name: "Jammu", placeId: "ChIJvT6MtUu24TkRU02H8SThDNE" },
  { name: "Dehradun", placeId: "ChIJr4jIVsMpCTkRmYdRMsBiNUw", url: Dehradun },
  { name: "Meerut", placeId: "ChIJJWO2V_RkDDkRXr6mhzOo-kI", url: Meerut },
  { name: "Bareilly", placeId: "ChIJjZkCTTMHoDkRf-ge80zUuQU", url: Bareilly },
  { name: "Pathankot", placeId: "ChIJs4Q8R11_HDkRiV1w7ptzNVM", url: Pathankot },
  { name: "Jaipur", placeId: "ChIJgeJXTN9KbDkRCS7yDDrG4Qw", url: Jaipur },
  {
    name: "Bhubaneswar",
    placeId: "ChIJpQoX1dIJGToRqD-zaCsOWPw",
    url: Bhubaneswar,
  },
  //   { name: "Nagpur", placeId: "ChIJ66bAnUtXyzsRP4WlW7czpEE" },
  {
    name: "Kathmandu-Nepal",
    placeId: "ChIJv6p7MIoZ6zkR6rGN8Rt8E7U",
    url: Kathmandu_Nepal,
  },
  { name: "Bangalore", placeId: "ChIJixmRVfERrjsR4-QBaxZrfW8", url: Banglore },
  { name: "Gwalior", placeId: "ChIJ-5EiedHFdjkR3zq8ZW21T_8", url: Gwalior },
  { name: "Zirakpur", placeId: "ChIJg_2xWjbrDzkRzOcYmjjv2Es", url: Zirakpur },
  { name: "Barabanki", placeId: "ChIJe8S5BkJgmTkRi8kfvbXFHBs", url: Barabanki },
];
